import { Alert, Card } from '@/lib';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const LatestReportGenerationWarning = () => {
  const { t } = useTranslation('marketIntelligence');

  return <Alert type='WARNING' title={t('report.latestGenerationFailed.title')} description={t('report.latestGenerationFailed.description')} />;
};

export const NoGeneratedReport = ({ isLatestGenerationWarning = false }) => {
  const { t } = useTranslation('marketIntelligence');

  return (
    <div className='w-full space-y-5'>
      {isLatestGenerationWarning ? <LatestReportGenerationWarning /> : null}
      <Card className='block rounded-lg border-primary-border bg-white p-6 drop-shadow-none'>
        <div className='py-12 text-center'>
          <h3 className='mb-2 text-lg font-semibold text-primary-900'>{t('report.empty.title')}</h3>
          <p className='text-primary-600'>{t('report.empty.description')}</p>
        </div>
      </Card>
    </div>
  );
};
